"use client";

import { useState } from "react";

interface VideoPlayerProps {
  src: string;
  poster?: string;
  title?: string;
  className?: string;
}

export default function VideoPlayer({
  src,
  poster,
  title,
  className = "",
}: VideoPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className={`relative w-full ${className}`}>
      <div className="relative aspect-video bg-black rounded-lg overflow-hidden">
        <video
          src={src}
          poster={poster}
          controls
          className="w-full h-full object-cover"
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        >
          您的浏览器不支持视频播放。
        </video>
        {title && (
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
            <h3 className="text-white font-medium">{title}</h3>
          </div>
        )}
      </div>
    </div>
  );
}

